/**
 * Получение значений перечисления через API метод
 * @param {string} enumClass
 * @returns {Promise<Object[]>}
 */
export const getEnumData = async (enumClass) => {
    return axios.get(route('api.v1.system.get-enum', enumClass))
        .then(resp => resp.data)
        .catch(err => null);
};

/**
 * Входит ли значение поля в список допустимых значений перечисления
 * @param enumData Все значения перечисления
 * @param allowedValues Допустимые значения перечисления
 * @param fieldValue Значение поля
 * @returns {boolean}
 */
export const fieldIsAllowedEnumValue = (enumData, allowedValues, fieldValue) => {
    const enumValue =  enumData.find(el => String(el.value) === String(fieldValue));

    if(!enumValue) { return false; }

    return allowedValues.includes(enumValue.sys_name)
        || allowedValues.includes(enumValue.value);
};

export const enumUtilsMixin = {
    methods: {
        getEnumData: getEnumData,
        fieldIsAllowedEnumValue: fieldIsAllowedEnumValue,
    }
};
